import MagicLinkLandingContainer from "./MagicLinkLandingContainer";

export default MagicLinkLandingContainer;
